import { render, staticRenderFns } from "./logoLogin.vue?vue&type=template&id=4a97fce3&"
import script from "./logoLogin.vue?vue&type=script&lang=js&"
export * from "./logoLogin.vue?vue&type=script&lang=js&"
import style0 from "./logoLogin.vue?vue&type=style&index=0&id=4a97fce3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports